// once we work on the functionality, the selectors will be created here
// sample code

import { createSelector } from 'reselect';
import { congratulationInitState } from './reducer';

const CongratulationPage = (state) => state.CongratulationPage || congratulationInitState;

const companyInfoCangratulationData = createSelector(CongratulationPage, (cnter) => cnter.companyInfoCangratulationData);

export default {
    companyInfoCangratulationData
};
